import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { GlobalState, SnackBarDto } from "./model";

const initialState: GlobalState = {
  snackBar: {
    open: false,
    message: "",
    severity: "info",
  },
  contactSupportModal: {
    description: "",
    visible: false,
  },
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    openSnackBar: (state, { payload }: PayloadAction<SnackBarDto>) => {
      state.snackBar = { ...payload, open: true };
    },
    closeSnackBar: (state) => {
      state.snackBar = initialState.snackBar;
    },

    setContactSupportModal: (state, { payload }: PayloadAction<string>) => {
      state.contactSupportModal = { visible: true, description: payload };
    },
    closeContactSupportModal: (state) => {
      state.contactSupportModal = initialState.contactSupportModal;
    },
  },
});

export const GlobalSliceAction = globalSlice.actions;
export const { openSnackBar } = globalSlice.actions;
export default globalSlice.reducer;
